/**
 * Build the Curation deep link for a gif's retrieval record. Records live in
 * PROD (source of truth); the emulator is a disposable mirror. So when this app
 * runs against the emulator we point at the absolute prod URL — the curator
 * fixes the record on prod and the emulator copy refreshes on the next
 * sync:pull. Otherwise (prod build) we stay same-origin with a relative path.
 */
export function curationDeepLink(gifId: string): string {
  const path = `/admin/curation?gif=${encodeURIComponent(gifId)}`
  return import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true'
    ? `https://cyranogifs.web.app${path}`
    : path
}
